export default {
  getProAccountLeftBarData: (state) => state.proAccountLeftBarData || null,
  getProPhonesAssignmentData: (state) => state.proPhonesAssignmentData || null,
  getProSellerPageData: (state) => state.proSellerPageData || null,
  getProBusinessFeaturesData: (state) => state.proBusinessFeaturesData,
  getProBusinessFeaturesDataById: (state) => state.proBusinessFeaturesDataById,
  isActiveProSeller: (state) => state.proSellerPageData?.active && state.proSellerPageData?.withPro,
};
